import { isNil } from 'lodash';

export default {
  isOneBallLeft: (state) => state.drawnBalls.length >= 34,
  numberOfSelectedBalls: (state) => (state.bet && state.bet.numbers ? state.bet.numbers.length : 0),
  bets: (state) => state.ticket.bets,
  isIsonis: (state) => state.isonisList.indexOf(state.config.taxAuthority) > -1,
  isBoostActive: (state) => state.config.ui.config?.boost?.enabled || false,
  isNextGen: (state) => state.config.platformName === 'NextGen',
  freeBetFeatureActive: (state) => state.config.ui.config.freeBetFeatureActive,
  customDomain: (state) => state.config.customDomain,
  customProductName: (state) => state.config.ui?.config?.customProductName,
  // TODO: Remove true default when all apps adapted and ensured all clients with custom/translated product name are adapted through static config
  translateProductName: (state) => state.config.ui?.config?.translateProductName ?? true,
  gameTitle: (state, getters) => {
    if (!isNil(getters.customProductName)) {
      return getters.customProductName;
    }
    return getters.translateProductName
      ? getters.translations?.[state.usePackageTranslations ? 'product_name' : 'general_productName_nextSix']
      : 'Next Six';
  },
};
